import { render, staticRenderFns } from "./RemissionsModalDetail.vue?vue&type=template&id=9dd02030"
import script from "./RemissionsModalDetail.vue?vue&type=script&lang=js"
export * from "./RemissionsModalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports